import { defineNuxtPlugin } from '#app/nuxt'
import { LazyActionsRowItem, LazyMiscMoleculesSection, LazyNavigationAppDropdown, LazyNavigationDashboard, LazyNavigationFooter, LazyNavigationLoader, LazyNavigationMainMenu, LazyNavigationUserMenu, LazyScriptAriaLoadingIndicator, LazyScriptCarbonAds, LazyScriptCrisp, LazyScriptGoogleAdsense, LazyScriptGoogleMaps, LazyScriptIntercom, LazyScriptLemonSqueezy, LazyScriptLoadingIndicator, LazyScriptStripePricingTable, LazyScriptVimeoPlayer, LazyScriptYouTubePlayer, LazyProseA, LazyProseBlockquote, LazyProseCode, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseImg, LazyProseLi, LazyProseOl, LazyProseP, LazyProsePre, LazyProseScript, LazyProseStrong, LazyProseTable, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl, LazyActionsDenseItem, LazyActionsExpandedItem, LazyActionsRowsItem, LazyActionsView, LazyAffiliationDenseItem, LazyAffiliationExpandedItem, LazyAffiliationRowsItem, LazyAffiliationView, LazyAffiliationsDenseItem, LazyAffiliationsExpandableDenseItem, LazyAffiliationsExpandedItem, LazyAffiliationsRowsItem, LazyAffiliationsView, LazyAppsDenseItem, LazyAppsExpandedItem, LazyAppsRowsItem, LazyAppsView, LazyDisciplinesDenseItem, LazyDisciplinesExpandedItem, LazyDisciplinesRowsItem, LazyDisciplinesView, LazyEventsBadges, LazyEventsDateTimePlace, LazyEventsDenseItem, LazyEventsExpandedItem, LazyEventsLocation, LazyEventsRegisterModal, LazyEventsRelatedItem, LazyEventsRowsItem, LazyEventsSlidingItem, LazyEventsView, LazyFellowshipsBadges, LazyFellowshipsDenseItem, LazyFellowshipsExpandedItem, LazyFellowshipsRegisterModal, LazyFellowshipsRowsItem, LazyFellowshipsView, LazyFilesDenseItem, LazyFilesExpandedItem, LazyFilesRowsItem, LazyFilesView, LazyListAtomsFiltersMenu, LazyListAtomsLogoPlaceholder, LazyListAtomsPerPage, LazyListAtomsResetButton, LazyListAtomsResultsList, LazyListAtomsSearchInput, LazyListAtomsSearchItem, LazyListAtomsSearchString, LazyListAtomsSortMenu, LazyListAtomsViewMenu, LazyListInputsAutoComplete, LazyListInputsBooleanSwitch, LazyListInputsCheckbox, LazyListInputsSelect, LazyListMoleculesDenseItemContainer, LazyListMoleculesFilters, LazyListMoleculesGlobalSearchInput, LazyListMoleculesHeader, LazyListMoleculesPagination, LazyListMoleculesResultsContainer, LazyListOrganismsList, LazyListOrganismsLoader, LazyListOrganismsResults, LazyListOrganismsSlider, LazyListViewsDense, LazyListViewsExpanded, LazyListViewsGrid, LazyListViewsRows, LazyListViewsSlider, LazyListViewsTable, LazyMailingDenseItem, LazyMailingExpandedItem, LazyMailingRowsItem, LazyMailingView, LazyMiscAtomsDateStamp, LazyMiscAtomsImageContainer, LazyMiscAtomsShareMenu, LazyMiscAtomsSocials, LazyMiscMoleculesChipContainer, LazyMiscMoleculesDisciplinesTags, LazyMiscMoleculesRelated, LazyMiscMoleculesRelatedItems, LazyMiscMoleculesSearchItem, LazyNewsDenseItem, LazyNewsExpandedItem, LazyNewsHeader, LazyNewsRelatedItem, LazyNewsRowsItem, LazyNewsView, LazyPeopleBadges, LazyPeopleDenseItem, LazyPeopleExpandableDenseItem, LazyPeopleExpandedItem, LazyPeopleRelatedItem, LazyPeopleRowsItem, LazyPeopleView, LazyProjectsDenseItem, LazyProjectsExpandedItem, LazyProjectsRelatedItem, LazyProjectsRowsItem, LazyProjectsView, LazyPublicationsDenseItem, LazyPublicationsRelatedItem, LazyPublicationsRowsItem, LazyPublicationsView, LazyTagsDenseItem, LazyTagsExpandedItem, LazyTagsRowsItem, LazyTagsView, LazyUsersDenseItem, LazyUsersExpandedItem, LazyUsersRowsItem, LazyUsersView, LazyFormAtomsAutoComplete, LazyFormAtomsBlockTitle, LazyFormAtomsBooleanSwitch, LazyFormAtomsCheckbox, LazyFormAtomsColorPicker, LazyFormAtomsDatePicker, LazyFormAtomsFileInput, LazyFormAtomsI18nTextArea, LazyFormAtomsI18nTextField, LazyFormAtomsSelect, LazyFormAtomsTextArea, LazyFormAtomsTextField, LazyFormAtomsPickerAffiliationItem, LazyFormAtomsPickerEventItem, LazyFormAtomsPickerImageItem, LazyFormAtomsPickerPeopleItem, LazyFormAtomsPickerProjectItem, LazyFormMoleculesAffiliationsPicker, LazyFormMoleculesCollectionContainerPanel, LazyFormMoleculesDeleteDialog, LazyFormMoleculesDocumentPicker, LazyFormMoleculesImagePicker, LazyFormMoleculesImageUploader, LazyFormMoleculesObjectCollapsiblePanel, LazyFormMoleculesObjectContainerPanel, LazyFormMoleculesObjectKeyPairContainer, LazyFormMoleculesOptions, LazyFormOrganismsForm, LazyFormOrganismsRecursiveFormblock } from '#components'
const lazyGlobalComponents = [
  ["ActionsRowItem", LazyActionsRowItem],
["MiscMoleculesSection", LazyMiscMoleculesSection],
["NavigationAppDropdown", LazyNavigationAppDropdown],
["NavigationDashboard", LazyNavigationDashboard],
["NavigationFooter", LazyNavigationFooter],
["NavigationLoader", LazyNavigationLoader],
["NavigationMainMenu", LazyNavigationMainMenu],
["NavigationUserMenu", LazyNavigationUserMenu],
["ScriptAriaLoadingIndicator", LazyScriptAriaLoadingIndicator],
["ScriptCarbonAds", LazyScriptCarbonAds],
["ScriptCrisp", LazyScriptCrisp],
["ScriptGoogleAdsense", LazyScriptGoogleAdsense],
["ScriptGoogleMaps", LazyScriptGoogleMaps],
["ScriptIntercom", LazyScriptIntercom],
["ScriptLemonSqueezy", LazyScriptLemonSqueezy],
["ScriptLoadingIndicator", LazyScriptLoadingIndicator],
["ScriptStripePricingTable", LazyScriptStripePricingTable],
["ScriptVimeoPlayer", LazyScriptVimeoPlayer],
["ScriptYouTubePlayer", LazyScriptYouTubePlayer],
["ProseA", LazyProseA],
["ProseBlockquote", LazyProseBlockquote],
["ProseCode", LazyProseCode],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseImg", LazyProseImg],
["ProseLi", LazyProseLi],
["ProseOl", LazyProseOl],
["ProseP", LazyProseP],
["ProsePre", LazyProsePre],
["ProseScript", LazyProseScript],
["ProseStrong", LazyProseStrong],
["ProseTable", LazyProseTable],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl],
["ActionsDenseItem", LazyActionsDenseItem],
["ActionsExpandedItem", LazyActionsExpandedItem],
["ActionsRowsItem", LazyActionsRowsItem],
["ActionsView", LazyActionsView],
["AffiliationDenseItem", LazyAffiliationDenseItem],
["AffiliationExpandedItem", LazyAffiliationExpandedItem],
["AffiliationRowsItem", LazyAffiliationRowsItem],
["AffiliationView", LazyAffiliationView],
["AffiliationsDenseItem", LazyAffiliationsDenseItem],
["AffiliationsExpandableDenseItem", LazyAffiliationsExpandableDenseItem],
["AffiliationsExpandedItem", LazyAffiliationsExpandedItem],
["AffiliationsRowsItem", LazyAffiliationsRowsItem],
["AffiliationsView", LazyAffiliationsView],
["AppsDenseItem", LazyAppsDenseItem],
["AppsExpandedItem", LazyAppsExpandedItem],
["AppsRowsItem", LazyAppsRowsItem],
["AppsView", LazyAppsView],
["DisciplinesDenseItem", LazyDisciplinesDenseItem],
["DisciplinesExpandedItem", LazyDisciplinesExpandedItem],
["DisciplinesRowsItem", LazyDisciplinesRowsItem],
["DisciplinesView", LazyDisciplinesView],
["EventsBadges", LazyEventsBadges],
["EventsDateTimePlace", LazyEventsDateTimePlace],
["EventsDenseItem", LazyEventsDenseItem],
["EventsExpandedItem", LazyEventsExpandedItem],
["EventsLocation", LazyEventsLocation],
["EventsRegisterModal", LazyEventsRegisterModal],
["EventsRelatedItem", LazyEventsRelatedItem],
["EventsRowsItem", LazyEventsRowsItem],
["EventsSlidingItem", LazyEventsSlidingItem],
["EventsView", LazyEventsView],
["FellowshipsBadges", LazyFellowshipsBadges],
["FellowshipsDenseItem", LazyFellowshipsDenseItem],
["FellowshipsExpandedItem", LazyFellowshipsExpandedItem],
["FellowshipsRegisterModal", LazyFellowshipsRegisterModal],
["FellowshipsRowsItem", LazyFellowshipsRowsItem],
["FellowshipsView", LazyFellowshipsView],
["FilesDenseItem", LazyFilesDenseItem],
["FilesExpandedItem", LazyFilesExpandedItem],
["FilesRowsItem", LazyFilesRowsItem],
["FilesView", LazyFilesView],
["ListAtomsFiltersMenu", LazyListAtomsFiltersMenu],
["ListAtomsLogoPlaceholder", LazyListAtomsLogoPlaceholder],
["ListAtomsPerPage", LazyListAtomsPerPage],
["ListAtomsResetButton", LazyListAtomsResetButton],
["ListAtomsResultsList", LazyListAtomsResultsList],
["ListAtomsSearchInput", LazyListAtomsSearchInput],
["ListAtomsSearchItem", LazyListAtomsSearchItem],
["ListAtomsSearchString", LazyListAtomsSearchString],
["ListAtomsSortMenu", LazyListAtomsSortMenu],
["ListAtomsViewMenu", LazyListAtomsViewMenu],
["ListInputsAutoComplete", LazyListInputsAutoComplete],
["ListInputsBooleanSwitch", LazyListInputsBooleanSwitch],
["ListInputsCheckbox", LazyListInputsCheckbox],
["ListInputsSelect", LazyListInputsSelect],
["ListMoleculesDenseItemContainer", LazyListMoleculesDenseItemContainer],
["ListMoleculesFilters", LazyListMoleculesFilters],
["ListMoleculesGlobalSearchInput", LazyListMoleculesGlobalSearchInput],
["ListMoleculesHeader", LazyListMoleculesHeader],
["ListMoleculesPagination", LazyListMoleculesPagination],
["ListMoleculesResultsContainer", LazyListMoleculesResultsContainer],
["ListOrganismsList", LazyListOrganismsList],
["ListOrganismsLoader", LazyListOrganismsLoader],
["ListOrganismsResults", LazyListOrganismsResults],
["ListOrganismsSlider", LazyListOrganismsSlider],
["ListViewsDense", LazyListViewsDense],
["ListViewsExpanded", LazyListViewsExpanded],
["ListViewsGrid", LazyListViewsGrid],
["ListViewsRows", LazyListViewsRows],
["ListViewsSlider", LazyListViewsSlider],
["ListViewsTable", LazyListViewsTable],
["MailingDenseItem", LazyMailingDenseItem],
["MailingExpandedItem", LazyMailingExpandedItem],
["MailingRowsItem", LazyMailingRowsItem],
["MailingView", LazyMailingView],
["MiscAtomsDateStamp", LazyMiscAtomsDateStamp],
["MiscAtomsImageContainer", LazyMiscAtomsImageContainer],
["MiscAtomsShareMenu", LazyMiscAtomsShareMenu],
["MiscAtomsSocials", LazyMiscAtomsSocials],
["MiscMoleculesChipContainer", LazyMiscMoleculesChipContainer],
["MiscMoleculesDisciplinesTags", LazyMiscMoleculesDisciplinesTags],
["MiscMoleculesRelated", LazyMiscMoleculesRelated],
["MiscMoleculesRelatedItems", LazyMiscMoleculesRelatedItems],
["MiscMoleculesSearchItem", LazyMiscMoleculesSearchItem],
["NewsDenseItem", LazyNewsDenseItem],
["NewsExpandedItem", LazyNewsExpandedItem],
["NewsHeader", LazyNewsHeader],
["NewsRelatedItem", LazyNewsRelatedItem],
["NewsRowsItem", LazyNewsRowsItem],
["NewsView", LazyNewsView],
["PeopleBadges", LazyPeopleBadges],
["PeopleDenseItem", LazyPeopleDenseItem],
["PeopleExpandableDenseItem", LazyPeopleExpandableDenseItem],
["PeopleExpandedItem", LazyPeopleExpandedItem],
["PeopleRelatedItem", LazyPeopleRelatedItem],
["PeopleRowsItem", LazyPeopleRowsItem],
["PeopleView", LazyPeopleView],
["ProjectsDenseItem", LazyProjectsDenseItem],
["ProjectsExpandedItem", LazyProjectsExpandedItem],
["ProjectsRelatedItem", LazyProjectsRelatedItem],
["ProjectsRowsItem", LazyProjectsRowsItem],
["ProjectsView", LazyProjectsView],
["PublicationsDenseItem", LazyPublicationsDenseItem],
["PublicationsRelatedItem", LazyPublicationsRelatedItem],
["PublicationsRowsItem", LazyPublicationsRowsItem],
["PublicationsView", LazyPublicationsView],
["TagsDenseItem", LazyTagsDenseItem],
["TagsExpandedItem", LazyTagsExpandedItem],
["TagsRowsItem", LazyTagsRowsItem],
["TagsView", LazyTagsView],
["UsersDenseItem", LazyUsersDenseItem],
["UsersExpandedItem", LazyUsersExpandedItem],
["UsersRowsItem", LazyUsersRowsItem],
["UsersView", LazyUsersView],
["FormAtomsAutoComplete", LazyFormAtomsAutoComplete],
["FormAtomsBlockTitle", LazyFormAtomsBlockTitle],
["FormAtomsBooleanSwitch", LazyFormAtomsBooleanSwitch],
["FormAtomsCheckbox", LazyFormAtomsCheckbox],
["FormAtomsColorPicker", LazyFormAtomsColorPicker],
["FormAtomsDatePicker", LazyFormAtomsDatePicker],
["FormAtomsFileInput", LazyFormAtomsFileInput],
["FormAtomsI18nTextArea", LazyFormAtomsI18nTextArea],
["FormAtomsI18nTextField", LazyFormAtomsI18nTextField],
["FormAtomsSelect", LazyFormAtomsSelect],
["FormAtomsTextArea", LazyFormAtomsTextArea],
["FormAtomsTextField", LazyFormAtomsTextField],
["FormAtomsPickerAffiliationItem", LazyFormAtomsPickerAffiliationItem],
["FormAtomsPickerEventItem", LazyFormAtomsPickerEventItem],
["FormAtomsPickerImageItem", LazyFormAtomsPickerImageItem],
["FormAtomsPickerPeopleItem", LazyFormAtomsPickerPeopleItem],
["FormAtomsPickerProjectItem", LazyFormAtomsPickerProjectItem],
["FormMoleculesAffiliationsPicker", LazyFormMoleculesAffiliationsPicker],
["FormMoleculesCollectionContainerPanel", LazyFormMoleculesCollectionContainerPanel],
["FormMoleculesDeleteDialog", LazyFormMoleculesDeleteDialog],
["FormMoleculesDocumentPicker", LazyFormMoleculesDocumentPicker],
["FormMoleculesImagePicker", LazyFormMoleculesImagePicker],
["FormMoleculesImageUploader", LazyFormMoleculesImageUploader],
["FormMoleculesObjectCollapsiblePanel", LazyFormMoleculesObjectCollapsiblePanel],
["FormMoleculesObjectContainerPanel", LazyFormMoleculesObjectContainerPanel],
["FormMoleculesObjectKeyPairContainer", LazyFormMoleculesObjectKeyPairContainer],
["FormMoleculesOptions", LazyFormMoleculesOptions],
["FormOrganismsForm", LazyFormOrganismsForm],
["FormOrganismsRecursiveFormblock", LazyFormOrganismsRecursiveFormblock],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
